'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { twMerge } from 'tailwind-merge';
import Typography from '../../../Base/Typography/Typography.js';
import Box from '../../../Base/Layouts/Box/Box.js';
import '../../../Base/Layouts/FullBleed/FullBleed.js';
import Radio from '../../Radio/Radio.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const RadioListItemContainer = (_param)=>{
    var { children, disabled, className, hasDescription } = _param, rest = _object_without_properties(_param, [
        "children",
        "disabled",
        "className",
        "hasDescription"
    ]);
    return /*#__PURE__*/ jsx("label", _object_spread_props(_object_spread({
        className: twMerge('grid h-min grid-cols-radio-list-item-container grid-rows-radio-list-item-container gap-x-3 grid-areas-radio-list-item-container', disabled ? 'cursor-not-allowed' : 'cursor-pointer', hasDescription ? 'gap-y-0.5' : 'gap-y-0', className)
    }, rest), {
        children: children
    }));
};
const RadioListItem = ({ name, value, label, description, isSelected, isDisabled = false, isError = false, className, RadioClassName, onChange })=>{
    return /*#__PURE__*/ jsxs(RadioListItemContainer, {
        "data-testid": "design-system-radioList--item",
        disabled: isDisabled,
        hasDescription: !!description,
        className: twMerge('group', className),
        children: [
            /*#__PURE__*/ jsx(Box, {
                className: "flex cursor-pointer pt-1 grid-in-radio",
                children: /*#__PURE__*/ jsx(Radio, {
                    name: name,
                    value: value,
                    isSelected: isSelected,
                    isError: isError,
                    isDisabled: isDisabled,
                    onChange: onChange,
                    className: RadioClassName
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                className: "flex w-full items-center grid-in-label",
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body1",
                    className: twMerge('w-full whitespace-normal break-words', isDisabled ? 'text-w-gray-300' : 'text-w-gray-900'),
                    "data-testid": "design-system-radioList--item-label",
                    children: label
                })
            }),
            description && /*#__PURE__*/ jsx(Box, {
                className: "flex items-center grid-in-description",
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: "body2",
                    className: isDisabled ? 'text-w-gray-300' : 'text-w-gray-600',
                    "data-testid": "design-system-radioList--item-description",
                    children: description
                })
            })
        ]
    });
};

export { RadioListItem as default };
